import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import Paragraph from "../atoms/Paragraph";
import Button from "../atoms/Button";
import ChevronRight from "../atoms/icons/ChevronRight";
import { useDispatch } from "react-redux";
import { withModal } from "../../contexts/ModalContext";
import { submitPaymentArrangementRequest } from "../../services/paymentService";
import { openPaymentArrangementAcceptedModal, openPaymentArrangementModal, openRequestedPaymentArrangementModal, } from "../../services/modalService";
import { updateDebtorEmail, updateDossier } from "../../store/actions";
import ErrorLabel from "../atoms/ErrorLabel";
import ChevronLeft from "../atoms/icons/ChevronLeft";
import { useTranslation } from "react-i18next";
import { moneyFormat } from "../../services/currencyService";
import { parseDate } from "../../services/dateService";
import { capitalize } from "lodash";
const StyledParagraph = styled(Paragraph) `
  font-weight: 700;
`;
const StyledParagraphValue = styled(Paragraph) `
  margin-bottom: 20px;
  line-height: 1.2rem;
`;
const StyledParagraphFirst = styled(Paragraph) `
  margin-bottom: 20px;
`;
const StyledLink = styled.a `
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  font-family: ${props => props.theme.fontBase};
  text-decoration: none;
  transition: background-color 0.2s ease-in-out;
  text-align: center;
  border: none;
  height: 50px;
  padding: 14px 24px;
  color: ${props => props.theme.tertiary};
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  background-color: #ffffff;
  margin-bottom: 15px;
  width: 100%;

  @media only screen and (min-width: 768px) {
    padding: 14px 24px 14px 34px;
    margin-bottom: 0;
    margin-right: 15px;
    width: auto;
  }
`;
const FooterContentContainer = styled.div `
  background: ${color.gray.lightest};
  padding: 20px 30px;
  margin: 0 -30px -30px -30px;
  z-index: 3;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;
const StyledChevronRight = styled(ChevronRight) `
  width: 6px;
  height: 12px;
  fill: ${color.body.base};
  margin-right: 10px;
`;
const StyledChevronLeft = styled(ChevronLeft) `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 15px;
  width: 6px;
  height: 12px;
  fill: ${props => props.theme.tertiary};
  margin-right: 10px;
`;
const SubmitPaymentArrangementModal = ({ showModal, request, hasMultipleDossiers, }) => {
    const { t } = useTranslation(["common", "dossier"]);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const goToNextStep = () => {
        const split = request.fullDate.replace(/_/g, "").split("-");
        const newDate = `${split[2]}-${split[1]}-${split[0]}`;
        const parsedDate = parseDate(newDate) || new Date();
        setLoading(true);
        submitPaymentArrangementRequest({
            amount: request.amount,
            email: request.email,
            startDate: parsedDate.toISOString().split("T")[0],
            forMultipleDossiers: request.forMultipleDossiers,
            proposition: request.proposition,
            totalBalance: request.totalBalance,
            minimumMonthlyPayment: request.minimumMonthlyPayment,
        })
            .then(response => {
            dispatch(updateDebtorEmail(request.email));
            if (response === "wait-for-approval") {
                dispatch(updateDossier({ hasPendingPaymentPlan: true }));
                openRequestedPaymentArrangementModal(showModal, request);
            }
            else if (response === "auto-approved") {
                // @todo, refresh actual payment plan
                dispatch(updateDossier({ hasPendingPaymentPlan: true }));
                openPaymentArrangementAcceptedModal(showModal, request);
            }
        })
            .catch(err => {
            console.log(err);
            setLoading(false);
            setError(err.errors[Object.keys(err.errors)[0]]);
        });
    };
    const goToPreviousStep = () => {
        openPaymentArrangementModal(showModal, request, hasMultipleDossiers);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledParagraphFirst, null, t("dossier:arrangement.confirm_input")),
        React.createElement(StyledParagraph, null, t("dossier:arrangement.confirm_monthly_amount")),
        React.createElement(StyledParagraphValue, null,
            moneyFormat(parseFloat((request.amount || "").replace(",", "."))),
            React.createElement(ErrorLabel, null, capitalize(error || ""))),
        React.createElement(StyledParagraph, null, t("dossier:arrangement.confirm_first_date")),
        React.createElement(StyledParagraphValue, null, request.fullDate),
        request.email && (React.createElement(React.Fragment, null,
            React.createElement(StyledParagraph, null, t("dossier:arrangement.confirm_email")),
            React.createElement(StyledParagraphValue, null, request.email))),
        request.forMultipleDossiers && (React.createElement(React.Fragment, null,
            React.createElement(StyledParagraphValue, null, t("dossier:arrangement.confirm_for_multiple_dossiers")))),
        React.createElement(FooterContentContainer, null,
            React.createElement(StyledLink, { onClick: goToPreviousStep },
                React.createElement(StyledChevronLeft, null),
                t("generic.go_back")),
            React.createElement(Button, { onClick: goToNextStep, loading: loading, tertiary: true, largeFont: true, bold: true, wide: true, reversed: true, icon: React.createElement(StyledChevronRight, null) }, t("dossier:arrangement.confirm_send")))));
};
export default withModal(SubmitPaymentArrangementModal);
